export default __webpack_public_path__ + "static/media/Sir-Marco.43816ff8.jpg";